class ShowroomRowSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector("[data-row-track]");
    this.prevButton = this.querySelector("[data-row-prev]");
    this.nextButton = this.querySelector("[data-row-next]");
    if (!this.track) return;

    this.update = () => this.updateArrows();
    this.prevButton?.addEventListener("click", () => this.scrollByPage(-1));
    this.nextButton?.addEventListener("click", () => this.scrollByPage(1));
    this.track.addEventListener("scroll", this.update, { passive: true });
    window.addEventListener("resize", this.update);

    // Cards (and their images) can change width as they load.
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.track);

    this.updateArrows();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.update);
    this.resizeObserver?.disconnect();
  }

  scrollByPage(direction) {
    this.track.scrollBy({ left: direction * this.track.clientWidth * 0.8, behavior: "smooth" });
  }

  updateArrows() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const scrollable = maxScroll > 1;

    if (this.prevButton) this.prevButton.hidden = !scrollable || this.track.scrollLeft <= 1;
    if (this.nextButton) this.nextButton.hidden = !scrollable || this.track.scrollLeft >= maxScroll - 1;
  }
}

if (!customElements.get("showroom-row-slider")) {
  customElements.define("showroom-row-slider", ShowroomRowSlider);
}
